import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      <p className="small-label">404</p>
      <h1 className="font-serif text-5xl mt-4">Lost in the boutique.</h1>
      <p className="text-stone mt-3">The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn-primary mt-8">Back to home</Link>
    </div>
  );
}
